import React from 'react';
import { ResponsiveContainer, LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { ChartDataPoint } from '../types';
interface TrendsSectionProps {
  data: ChartDataPoint[];
}
const CustomTooltip = ({
  active,
  payload,
  label
}: any) => {
  if (active && payload && payload.length) {
    return <div className="glass-panel rounded-xl p-4 border border-white/10 shadow-2xl" data-id="element-441">
        <p className="text-white font-semibold mb-2" data-id="element-442">{label}</p>
        {payload.map((entry: any, index: number) => <div key={index} className="flex items-center gap-2 text-sm" data-id="element-443">
            <div className="w-2 h-2 rounded-full" style={{
          backgroundColor: entry.color
        }} data-id="element-444" />
            <span className="text-slate-300" data-id="element-445">{entry.name}:</span>
            <span className="text-white font-medium" data-id="element-446">
              {entry.name === 'Revenue ($M)' ? `$${entry.value}M` : `$${entry.value}M`}
            </span>
          </div>)}
      </div>;
  }
  return null;
};
export function TrendsSection({
  data
}: TrendsSectionProps) {
  return <section className="mb-12" data-id="element-447">
      <h2 className="text-xl font-semibold text-white mb-6" data-id="element-448">
        Performance Trends
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-449">
        {/* Revenue Trend */}
        <div className="glass-panel rounded-3xl p-6" data-id="element-450">
          <h3 className="text-sm font-medium text-slate-400 mb-6" data-id="element-451">
            Revenue Growth (6 Months)
          </h3>
          <div className="h-72 w-full" data-id="element-452">
            <ResponsiveContainer width="100%" height="100%" data-id="element-453">
              <LineChart data={data} margin={{
              top: 5,
              right: 20,
              bottom: 5,
              left: 0
            }} data-id="element-454">
                <CartesianGrid strokeDasharray="3 3" stroke="#ffffff10" vertical={false} data-id="element-455" />
                <XAxis dataKey="name" stroke="#94a3b8" fontSize={12} tickLine={false} axisLine={false} data-id="element-456" />
                <YAxis stroke="#94a3b8" fontSize={12} tickLine={false} axisLine={false} tickFormatter={val => `$${val}M`} data-id="element-457" />
                <Tooltip content={<CustomTooltip data-id="element-459" />} data-id="element-458" />
                <Legend iconType="circle" wrapperStyle={{
                fontSize: '12px',
                color: '#94a3b8'
              }} data-id="element-460" />
                <Line type="monotone" name="Revenue ($M)" dataKey="revenue" stroke="#818cf8" strokeWidth={3} dot={{
                r: 4,
                fill: '#818cf8',
                strokeWidth: 0
              }} activeDot={{
                r: 6,
                fill: '#fff',
                stroke: '#818cf8',
                strokeWidth: 2
              }} data-id="element-461" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Volume Trend */}
        <div className="glass-panel rounded-3xl p-6" data-id="element-462">
          <h3 className="text-sm font-medium text-slate-400 mb-6" data-id="element-463">
            Volume Production (6 Months)
          </h3>
          <div className="h-72 w-full" data-id="element-464">
            <ResponsiveContainer width="100%" height="100%" data-id="element-465">
              <BarChart data={data} margin={{
              top: 5,
              right: 20,
              bottom: 5,
              left: 0
            }} data-id="element-466">
                <CartesianGrid strokeDasharray="3 3" stroke="#ffffff10" vertical={false} data-id="element-467" />
                <XAxis dataKey="name" stroke="#94a3b8" fontSize={12} tickLine={false} axisLine={false} data-id="element-468" />
                <YAxis stroke="#94a3b8" fontSize={12} tickLine={false} axisLine={false} tickFormatter={val => `$${val}M`} data-id="element-469" />
                <Tooltip content={<CustomTooltip data-id="element-471" />} data-id="element-470" />
                <Legend iconType="circle" wrapperStyle={{
                fontSize: '12px',
                color: '#94a3b8'
              }} data-id="element-472" />
                <Bar name="Volume ($M)" dataKey="volume" fill="#34d399" radius={[4, 4, 0, 0]} barSize={32} data-id="element-473" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </section>;
}